import { Component, OnInit, ViewChild } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { NewJobService } from '../app-service/newJob.service';
import { SharedService } from '../app-service/shared.service';
import {  MatTable,MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../app-service/auth.service';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
export interface JobIdList {
  // status: boolean;
  // JobId: number;
  // created_date: string;
  // mva:string;

  SeqNo:number,
  RepairOrderId:number,
  wwid:number,
  employeeName:any,
  MVA:string,
  REGO:string,
  model:any,
  km:any,
  starttime:string,
  endtime:string,
  status:any,
  radiobutton:any,
  OthersId:number,
  PMId:number,
  SubletId:number,
  TimearrayId:number,
  TyreId:number,
  pm:any,
  other:any,
  sublet:any,
  tyre:any,
  timearray:any

}

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.css'],
})
export class ContainerComponent implements OnInit {
  searchValue:any
  showWorkCompleted: boolean = true;
  showWorkInProgress: boolean = false;
  values:any;
  dataSource1:any;
  dataSource:any;
  displayedColumnsWC:any
  displayedColumnsWIP:any
  permissionList: any
  isAllowed: boolean = false;
   MVA:any;
   REGO:any="";
   model:any="";
   employeeName:any="";
   radiobutton:any=""
    sv=false
    infoimg:string="assets/images/info.png";
    searchimg:string="assets/images/search.png";
  constructor(
    private route: ActivatedRoute,
    private newJobService: NewJobService,private authService:AuthService,
    private sharedService: SharedService) { }
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort,{static:false}) sort: MatSort;
    statusClass1 :any;
    statusClass2 :any;
  showWC: any = localStorage.getItem("showWorkCompleted");
  showWIP: any = localStorage.getItem("showWorkInProgress");
  selectedJobType: any = 'ALL';
  ngOnInit(): void {
    this.permissionList = localStorage.getItem('userPermissions');
    
    //condition to check which page to open (work completed or work in progress) if we return from job details page
      if (this.showWC === 'false' && this.showWIP === 'true') {
        this.sharedService.wc = false;
        this.sharedService.wip = true;
        
        this.searchValue = localStorage.getItem("searchValue") != "null" ? localStorage.getItem("searchValue") : "";
        this.selectedJobType = localStorage.getItem("selectedJobType") != null ? localStorage.getItem("selectedJobType") : "ALL";
        this.itemSelect(this.selectedJobType);

      } else if (this.showWC === 'true' && this.showWIP === 'false') {
        this.sharedService.wc = true;
        this.sharedService.wip = false;
        
        this.searchValue = localStorage.getItem("searchValue") != "null" ? localStorage.getItem("searchValue") : "";
        this.selectedJobType = localStorage.getItem("selectedJobType") != null ? localStorage.getItem("selectedJobType") : "ALL";
        
        this.applyFilter(this.searchValue).then(() => {
          this.itemSelect(this.selectedJobType);
});
      }

      
    //console.log(this.authService.isloggedIn)
      this.showWorkCompleted=this.sharedService.wc;
      this.showWorkInProgress=this.sharedService.wip;
     // console.log(this.showWorkCompleted);
     // console.log(this.showWorkInProgress)
      if(this.showWorkInProgress)
      {
          // this.setActiveClass2()
          this.statusClass2='active'
          this.statusClass1='not-active'
      }
      else{
        this.statusClass1='active';
        this.statusClass2='not-active'
      }
    
    
    //console.log(localStorage.getItem('userDetails'));
    let jsonObj=JSON.parse(localStorage.getItem('userDetails')!)
    this.sharedService.wwidAndUsername(jsonObj)
    this.getAllJobListData()
     
  }
 
  getAllJobListData()
  {
    //console.log(this.sharedService.userData.wwid)
      this.newJobService.getAllJobListByWWID(this.sharedService.userData.wwid,this.selectedJobType).subscribe((data:any)=>{

      this.values=data.Model;
    
      const ELEMENT_DATA: JobIdList[]=this.values
      //console.log(ELEMENT_DATA)
    
    const wc: JobIdList[]=[];
    const wip: JobIdList[]=[];
    //wc:Work completed
    //wip:work in progress
    for(let i=ELEMENT_DATA.length-1;i>=0;i--)
    {
    if(ELEMENT_DATA[i].status=="true")
    {
      //we will split by T in string bcs til the T it will contain date Format
      var date=ELEMENT_DATA[i].endtime.split('T');
      //split date which we r getting in this format ex. 2020-12-03(YYYY-MM-DD) to ex.03-12-2020(dd/mm/YYYY)
      var s=date[0].split('-')
      ELEMENT_DATA[i].endtime=s[2]+'/'+s[1]+"/"+s[0];
      // ELEMENT_DATA[j].RepairOrderId= ELEMENT_DATA[i].RepairOrderId;

      wc.push(ELEMENT_DATA[i]);
      //wc.sort((x,y)=> +new Date(x.endtime) - +new Date(y.endtime));
    }
    if(ELEMENT_DATA[i].status=="false")
    {
      //we will split by T in string bcs til the T it will contain date Format
      var date=ELEMENT_DATA[i].starttime.split('T');
      //split date which we r getting in this format ex. 2020-12-03(YYYY-MM-DD) to ex.03-12-2020(dd/mm/YYYY)
        var s=date[0].split('-')
        ELEMENT_DATA[i].starttime=s[2]+'/'+s[1]+"/"+s[0];
      //ELEMENT_DATA[i].RepairOrderId= ELEMENT_DATA[j].RepairOrderId;
        wip.push(ELEMENT_DATA[i]);
      // wip.sort((x,y)=> +new Date(x.starttime) - +new Date(y.starttime));
    }
    }
    //console.log(wc)
      
    //console.log(wip);
      
    //this.dataSource: MatTableDataSource<wc>;
    this.dataSource =new MatTableDataSource(wc);
    this.dataSource.sortingDataAccessor = (item :any, property:any) => {
      switch (property) {
        case 'endtime': {
          var i = item.endtime.split('/');
          return new Date(i[1]+'/'+i[0]+'/'+i[2]);
        }
        default: return item[property];
      }
    };
    this.dataSource1=new MatTableDataSource(wip);
    this.dataSource1.sortingDataAccessor = (item :any, property:any) => {
      switch (property) {
        case 'starttime':  {
          var i = item.starttime.split('/');
          return new Date(i[1]+'/'+i[0]+'/'+i[2]);
        }
        default: return item[property];
      }
    };
    this.dataSource.paginator=this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource1.sort = this.sort;
    this.dataSource1.paginator=this.paginator;
    //to display details of perticular job passed details column
    this.displayedColumnsWC= ['RepairOrderId','radiobutton', 'REGO','endtime','name','details'];
    this.displayedColumnsWIP= ['RepairOrderId','radiobutton','REGO', 'starttime','name','details'];
    if(this.showWorkInProgress)
    {
      this.applyFilter1(this.searchValue);
    }
    })
  }

  applyFilter1(filterValue:string)
  {
    debugger
    this.dataSource.filter=filterValue.trim();
    this.dataSource1.filter=filterValue.trim();
    //localStorage.setItem("searchValue", filterValue);
  }
  applyFilter(filterValue:string): Promise<void>
  {
    return new Promise((resolve) => {
    // this.dataSource.filter=filterValue.trim();
    // this.dataSource1.filter=filterValue.trim();
    //localStorage.setItem("searchValue", filterValue);

    let getJobDetailsByUser = this.newJobService.getJobDetailsByUser(filterValue); //this.http.get(url);
    getJobDetailsByUser.subscribe(
      (mvadata: any) => {
      //////
      this.values=mvadata.Model;
    
      const ELEMENT_DATA: JobIdList[]=this.values
      //console.log(ELEMENT_DATA)
    
      const wc: JobIdList[]=[];
      //wc:Work completed
        
      for(let i=ELEMENT_DATA.length-1;i>=0;i--)
    {
    if(ELEMENT_DATA[i].status=="true")
    {
      //we will split by T in string bcs til the T it will contain date Format
      var date=ELEMENT_DATA[i].endtime.split('T');
      //split date which we r getting in this format ex. 2020-12-03(YYYY-MM-DD) to ex.03-12-2020(dd/mm/YYYY)
      var s=date[0].split('-')
      ELEMENT_DATA[i].endtime=s[2]+'/'+s[1]+"/"+s[0];
      // ELEMENT_DATA[j].RepairOrderId= ELEMENT_DATA[i].RepairOrderId;

      wc.push(ELEMENT_DATA[i]);
      //wc.sort((x,y)=> +new Date(x.endtime) - +new Date(y.endtime));
    }
      }
      //console.log(wc)


      //this.dataSource: MatTableDataSource<wc>;
      this.dataSource =new MatTableDataSource(wc);
      this.dataSource.sortingDataAccessor = (item :any, property:any) => {
      switch (property) {
        case 'endtime': {
          var i = item.endtime.split('/');
          return new Date(i[1]+'/'+i[0]+'/'+i[2]);
        }
        default: return item[property];
      }
      };

      this.dataSource.paginator=this.paginator;
      this.dataSource.sort = this.sort;
      //to display details of perticular job passed details column
      this.displayedColumnsWC= ['RepairOrderId','radiobutton', 'REGO','endtime','name','details'];
    
  
       ///////
      resolve();
    },
      (error) => console.log('Enter MVA ID')
    
    );
    });
  }


  toggleTag1() {
    this.setActiveClass1()
    this.showWorkCompleted = true;
    this.showWorkInProgress = false;
    localStorage.setItem("showWorkCompleted", "true");
    localStorage.setItem("showWorkInProgress", "false");
    //console.log('Button1 clicked');
    this.searchValue=""
    this.sharedService.buttonClicked(this.showWorkCompleted,this.showWorkInProgress)
    this.selectedJobType = "ALL";
    this.getAllJobListData();
  }
  toggleTag2() {
    this.setActiveClass2()
    this.showWorkCompleted = false;
    this.showWorkInProgress = true;
    localStorage.setItem("showWorkCompleted", "false");
    localStorage.setItem("showWorkInProgress", "true");
    this.sharedService.buttonClicked(this.showWorkCompleted,this.showWorkInProgress)
    //console.log('Button2 clicked');
    this.searchValue=""
    this.selectedJobType = "ALL";
    this.getAllJobListData();
  }
  
  setActiveClass1() {
    this.statusClass1 = 'active';
    this.statusClass2 = 'not-active';
  }
  setActiveClass2() {
    this.statusClass2 = 'active';
    this.statusClass1 = 'not-active';
  }
  //called when user click on row from container.html component
  getJobId(id: any) {
    localStorage.setItem("searchValue", this.searchValue);
    localStorage.setItem("selectedJobType", this.selectedJobType);
    //if user clicked workInProgress then Clock should display so this method passing boolean value to shared service
    this.sharedService.clockDisplayOnSelectFeatureComponent(this.showWorkInProgress);
    //this will store jobId on newJobService nd we can call get method to url from selectFeature
    this.newJobService.storeJobIdOnNewService(id);
    localStorage.setItem('JobId',id);
  }
  displayAtJobId(id:any)
  {
   //console.log("Selected JobId=");
    //console.log(id)
    for(let i=0;i<this.values.length;i++)
    {
      if(id==this.values[i].RepairOrderId)
      {
        //console.log(this.values[i].RepairOrderId)
        this.MVA=this.values[i].MVA;
        this.model=this.values[i].model;
        if(this.values[i].radiobutton=="Hanback/buyback")
        {
          this.radiobutton="Handback/buyback"
        }
        else{
        this.radiobutton=this.values[i].radiobutton;
        }

        break;
      }
    }
    //if(id==this.values)
    //console.log(this.values.length)

  }
  itemSelect(newVal: any) {

    this.selectedJobType = newVal;
    
    this.getAllJobListData();

  }
  ngOnDestroy() {
    
  }
}
